const initialState = {
  fetched: false,
  allUsers: [],
  currentUser: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FETCHED_USER":
      return {
        ...state,
        fetched: true,
        allUsers: state.allUsers.concat(action.data),
      };
    case "ADDED_USER":
      return {
        ...state,
        allUsers: [action.data].concat(state.allUsers),
      };
    case "UPDATED_USER":
      return {
        ...state,
        allUsers: state.allUsers.map((user) => (user.id === action.data.id ? action.data : user)),
      };
    case "CURRENT_USER":
      return {
        ...state,
        currentUser: action.data,
      };
    case "DELETED_USER":
      return {
        ...state,
        allUsers: state.allUsers.filter((user) => user.id !== action.userId),
      };
    case "LOGOUT":
      return {
        ...state,
        fetched: false,
        allUsers: [],
      };
    default:
      return state;
  }
};
